import { ApplicationRef, Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SocketService {

  // Tracks which user id the current socket was opened for, so repeated
  // connect() calls (one per component that uses the socket) become a
  // no-op instead of leaking a new socket.io-client connection each time.
  private connectedId: string | null = null;

  constructor(
    private socket : Socket,
    private appRef: ApplicationRef
  ) { }

  connect() {
    const id = localStorage.getItem('id');
    if (!id) {
      console.error('User ID is not available in localStorage!');
      return;
    }

    // Already have a live connection for this user - do nothing.
    if (this.connectedId === id && this.socket?.ioSocket?.connected) {
      return;
    }

    // Close out any existing connection first - either a stale one for a
    // different user, or the DI-provided singleton from SocketConfigModule,
    // which auto-connects (unauthenticated, no id) as soon as SocketService
    // is first injected, before connect() is ever called.
    if (this.socket) {
      this.socket.disconnect();
    }

    const url = `${environment.SOCKET_BASE_URL}?id=${id}`;

    // Dynamically initialize the socket
    this.socket = new Socket({ url, options: {} }, this.appRef);

    this.socket.connect();
    this.connectedId = id;

    // Handle socket events
    this.socket.fromEvent('connect').subscribe(() => {
      console.log('Socket connected successfully!');
    });

    this.socket.fromEvent('connect_error').subscribe((err: any) => {
      console.error('Socket connection error:', err);
    });

    this.socket.fromEvent('disconnect').subscribe(() => {
      console.log('Socket disconnected');
      this.connectedId = null;
    });
  }

  /**
   * Closes the current connection. Only call this on logout / app teardown -
   * not from individual components' ngOnDestroy, since the socket is shared
   * app-wide.
   */
  disconnect() {
    if (!this.socket) {
      return;
    }
    this.socket.disconnect();
    this.connectedId = null;
  }




  /**
   * Listens for an event with the specified name on the socket.
   *
   * @param eventName The name of the event to listen for.
   * @returns An Observable that emits the event data when the event occurs.
   */
  listen(eventName: string): Observable<any> {
    console.log('socket values',this.socket.fromEvent(eventName))
      return this.socket.fromEvent(eventName);   
  }

  /**
   * Emits an event with the specified name and data to the socket.
   *
   * @param event The name of the event to emit.
   * @param data The data to send with the event.
   */
  emit(event: string, data: any) {
    this.socket.emit(event, data);
  }

  /**
   * Listens for an event with the specified name on the socket.
   *
   * @param event The name of the event to listen for.
   * @returns An Observable that emits the event data when the event occurs.
   *
   * Note: This observable will automatically unsubscribe from the event when
   * the observable is complete or unsubscribed from.
   */
  on(event: string): Observable<any> {
    return new Observable((observer) => {
      this.socket.on(event, (data: any) => {
        console.log('data', data);        
        observer.next(data);
      });
      return () => {
        this.socket.off(event);
      }
    })
  }
}


